import axios from "./configs/axiosConfig";

export const verifyWorkizAccount = async (reqData) => {
  const url = `/workiz/accountverify?accountId=${reqData}`;
  return await axios.get(url);
};
